'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002491 from "./presto.-Presto-Router$$anon$91.js";
import * as $j_presto$002e$002dRegister$002dDirective$002dPage$0024 from "./presto.-Register-Directive-Page$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$90() {
  this.bpb = null;
  this.bp3 = null;
  this.bp4 = false;
  this.bpc = null;
  this.bpd = false;
  this.bpg = null;
  this.bp9 = null;
  this.bpa = false;
  this.bp5 = null;
  this.bp6 = false;
  this.bp7 = null;
  this.bp8 = false;
  this.bpe = false;
  this.bpf = false;
  this.bpb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bpg = "RegisterDirectivePage";
}
export { $c_Lpresto_PrestoRouter$$anon$90 as $c_Lpresto_PrestoRouter$$anon$90 };
$p = $c_Lpresto_PrestoRouter$$anon$90.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$90;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$90() {
}
export { $h_Lpresto_PrestoRouter$$anon$90 as $h_Lpresto_PrestoRouter$$anon$90 };
$h_Lpresto_PrestoRouter$$anon$90.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bpb;
});
$p.L = (function() {
  if ((!this.bp4)) {
    this.bp3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bp4 = true;
  }
  return this.bp3;
});
$p.O = (function() {
  if ((!this.bpd)) {
    this.bpc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bpd = true;
  }
  return this.bpc;
});
$p.E = (function() {
  return this.bpg;
});
$p.t = (function() {
  if ((!this.bpa)) {
    this.bp9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("url", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selector", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bpa = true;
  }
  return this.bp9;
});
$p.M = (function() {
  if ((!this.bp6)) {
    this.bp5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bp6 = true;
  }
  return this.bp5;
});
$p.Q = (function() {
  if ((!this.bp8)) {
    this.bp7 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002491.$c_Lpresto_PrestoRouter$$anon$91();
    this.bp8 = true;
  }
  return this.bp7;
});
$p.w = (function() {
  if ((!this.bpf)) {
    this.bpe = false;
    this.bpf = true;
  }
  return this.bpe;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee576) => ((p) => \u03b4scrutinee576.cG8(p)))($j_presto$002e$002dRegister$002dDirective$002dPage$0024.$m_Lpresto_RegisterDirectivePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$90 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$90, "presto.PrestoRouter$$anon$90", ({
  OZ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$90 as $d_Lpresto_PrestoRouter$$anon$90 };
//# sourceMappingURL=presto.-Presto-Router$$anon$90.js.map
